<template>
  <div class="indicator-name-cell">
    <Tooltip v-if="tooltip" class="indicator-name-cell__info" nameIcon="tooltip-info">{{ tooltip }}</Tooltip>
    <span>{{ name }}</span>
  </div>
</template>

<script>
  import Tooltip from '@/common/ui/Tooltip.vue';

  export default {
    name: 'IndicatorNameCell',
    components: { Tooltip },
    props: {
      name: {
        type: String,
        default: '',
      },
      tooltip: {
        type: String,
        default: '',
      },
    },
  };
</script>

<style lang="scss" scoped>
  .indicator-name-cell {
    display: flex;
    align-items: center;
    gap: 6px;

    &__info {
      flex-shrink: 0;
    }
  }
</style>
